module.exports = __webpack_public_path__ + "static/img/banner.df426fdf.jpg";